import {encode} from './encode';
import {minutes, pick, find, moment, createReducer, objectDifference, reject, get} from 'helpers';
import {isGoogleEventId} from 'store/google-calendar';

export const changes = createReducer([], {
  APP_DATA_CHANGED: (state, { id, action, select, initiator, model, modelType, now, prev, }) => {
    //do not queue changes if not logged in
    if (!select('googleCalendar.user')) {
      return state;
    }

    //queue only activities and statuses changes (not intiated by google)
    if (/^(GOOGLE_CALENDAR_|ACTIVITIES_STORE_GOOGLE_EVENT)/.test(initiator) || !/^(statuses|activities)$/.test(modelType)) {
      return state;
    }

    const change = {
      action,
      attempts: 0,
      id,
    }

    switch (modelType + '_' + action) {
      case 'activities_create':
        if (model.googleCalendarId) {
          change.payload = {
            calendarId: model.googleCalendarId,
            resource: encode(model),
          }
        }
        break;

      case 'activities_update':
        if (now.googleEventId && now.googleCalendarId && now.googleCalendarId == prev.googleCalendarId) {
          change.payload = {
            eventId: now.googleEventId,
            calendarId: now.googleCalendarId,
            resource: objectDifference(encode(now), encode(prev)),
          }
        } else if (now.googleEventId && now.googleCalendarId && prev.googleCalendarId && now.googleCalendarId != prev.googleCalendarId) {
          change.action = 'move';
          change.payload = {
            eventId: prev.googleEventId,
            calendarId: prev.googleCalendarId,
            destination: now.googleCalendarId,
          }
        } else if (!now.googleCalendarId && prev.googleCalendarId) {
          change.action = 'delete';
          change.payload = {
            eventId: prev.googleEventId,
            calendarId: prev.googleCalendarId,
          }
        } else if (!now.googleEventId && now.googleCalendarId) {
          change.action = 'create';
          change.payload = {
            calendarId: now.googleCalendarId,
            resource: encode(now),
          }
        }
        break;

      case 'activities_delete':
        if (model.googleCalendarId && model.googleEventId) {
          change.payload = {
            eventId: model.googleEventId,
            calendarId: model.googleCalendarId,
          }
        }
        break;

      case 'statuses_create':
        if (model.status != 'Rescheduled') {
          const { googleCalendarId, googleEventId, time, ...activity } = select('activities.activity', { id: model.activity_id });
          if (googleCalendarId && googleEventId) {
            const date = moment.unix(model.originalTimestamp);
            change.payload = {
              calendarId: googleCalendarId,
              resource: {
                ...encode({
                  ...activity,
                  repeatType: null,
                  ts: model.timestamp,
                  time: model.priority,
                }),
                recurringEventId: googleEventId,
                originalStartTime: {
                  date: time ? null : date.format('YYYY-MM-DD'),
                  dateTime: time ? date.add(minutes(time), 'minutes').format(moment.ISO8601) : null,
                  timeZone: time ? Intl.DateTimeFormat().resolvedOptions().timeZone : null,
                },
              }
            }
          }
        }
        break;

      case 'statuses_update':
        if (now.status != 'Rescheduled') {
          const { googleCalendarId, googleEventId, ...activity } = select('activities.activity', { id: now.activity_id });
          const match = find(select('googleCalendar.eventsProgress'), ({ activity_id, timestamp }) => activity_id == prev.activity_id && timestamp == prev.timestamp);
          if (googleCalendarId && googleEventId && match) {
            change.action = 'update';
            change.payload = {
              eventId: match.id.replace(/^g_/, ''),
              calendarId: googleCalendarId,
              resource: pick(encode({
                ...activity,
                repeatType: null,
                ts: now.timestamp,
                time: now.priority,
              }), 'start', 'end'),
            }
          }
        }
        break;
    }

    return change.payload ? [...state, change] : state;
  },

  GOOGLE_CALENDAR_SUCCESSFUL_CHANGE: (state, action) => {
    return reject(state, action.change);
  },

  GOOGLE_CALENDAR_ERROR: (state, action) => {
    if (get(action.error, 'code') == -1) {
      //network error
      return state.map(change => {
        change = {
          ...change,
          attempts: change.attempts + 1,
        }
        return change.attempts < 4 && change;
      }).filter(Boolean);
    }
    return reject(state, action.change);
  },

  ACTIVITIES_DELETE: (state, action) => {
    if (isGoogleEventId(action.id)) {
      const { googleCalendarId, googleEventId } = action.select('activities.activity', { id: action.id });
      return [
        ...state,
        {
          action: 'delete',
          attempts: 0,
          id: action.id,
          payload: {
            eventId: googleEventId,
            calendarId: googleCalendarId || 'primary',
          }
        }
      ];
    }
    return state;
  },

  GOOGLE_CALENDAR_SIGNED_OUT: () => [],

});
